import React from "react";
import { Link } from "react-router-dom";
import image from "../../assets/bookcard2.png"

const BookCard = ({book}) => {
  return (
    <Link
      to={`/qs-academy/bookstore/${book?.id}`}
      className="w-full flex flex-col gap-4 p-4 rounded-md mt-[5rem]"
    >
      <div className="relative w-full min-h-[150px] ">
        {/* Background layer */}
        <div
          className="absolute inset-0 bg-contain bg-no-repeat bg-center opacity-20"
          style={{
            backgroundImage:
              `url(${image})`,
          }}
        ></div>

        {/* Centered book image */}
        <img
          src={`${import.meta.env.VITE_API_BASE_URL}/storage/${book.image}`}
          alt={book.title}
          className="absolute top-[-3rem] left-1/2 w-[200px] h-[290px]  transform -translate-x-1/2 -translate-y-1/2 z-10"
        />
      </div>

      <div className="flex flex-col gap-2 justify-center items-center text-center">
        <h1 className="text-[#bfbfbf] text-base font-medium">
          {book.title}
        </h1>
        <h4 className="text-base text-[#bfbfbf]">Written by {book.author_name}</h4>
        <h2 className="text-2xl font-bold text-[#22BEFF]">{book.current_price}/-</h2>
      </div>
    </Link>
  );
};

export default BookCard;
